
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.5 6H4a2 2 0 00-2 2v1a2 2 0 002 2h7V8a1 1 0 112 0v3h7a2 2 0 002-2V8a2 2 0 00-2-2h-2.5a2.5 2.5 0 00-2-4h-.202c-.82 0-1.596.373-2.11 1.014L12 4.5l-1.189-1.486A2.702 2.702 0 008.701 2H8.5a2.5 2.5 0 00-2 4zm2.75-1.737L9.838 5H8.5a.5.5 0 010-1h.202c.213 0 .414.097.547.263zM14.16 5l.59-.737A.701.701 0 0115.298 4h.202a.5.5 0 010 1h-1.339z"}}),_c('path',{attrs:{"d":"M11 13H4c-.512 0-1 .373-1 .884V19a3 3 0 003 3h5v-9zM13 22h5a3 3 0 003-3v-5.116c0-.511-.488-.884-1-.884h-7v9z"}})])
          )
        }
      }
    